import React from 'react';
import { FadeIn } from './ui';
import { Leaf } from 'lucide-react';
const includes = ["El Manual Maestro 'Metabolismo 40+ Reset' (PDF) paso a paso.", 'El Protocolo de Choque de 21 días para desinflamar tu abdomen.', 'La Guía de Alimentación Sincrónica: Qué comer y cuándo según tu reloj biológico.', 'El Checklist de Inventario Hormonal para identificar tus bloqueos hoy mismo.', "Planificador de Compras 'Zero Inflamación' para ir directo a lo que funciona.", 'Rutina Sugerida de 5 Minutos para reactivar tu sistema linfático cada mañana.'];
export function WhatYouGetSection() {
  return <section className="bg-cream py-20 px-6 md:py-28" data-id="element-168">
      <div className="max-w-5xl mx-auto" data-id="element-169">
        <FadeIn data-id="element-170">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy text-center mb-16" data-id="element-171">
            ¿Qué Incluye Tu Reset?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-172">
          {includes.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-173">
              <div className="bg-white p-6 rounded-2xl shadow-sm flex items-start gap-4 border border-sage/50 hover:shadow-md transition-shadow" data-id="element-174">
                <div className="bg-sage/30 p-3 rounded-full flex-shrink-0" data-id="element-175">
                  <Leaf className="w-6 h-6 text-navy" data-id="element-176" />
                </div>
                <p className="text-lg text-navy font-medium pt-2 leading-snug" data-id="element-177">
                  {item}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}